// extracted by mini-css-extract-plugin
module.exports = {"app_footer":"Footer_app_footer__TURw_","footer_title":"Footer_footer_title__ZEPlL","logo_block":"Footer_logo_block__hqZQX"};